import React, { useEffect, useState } from 'react';

const TblOrderStatuselect = (props) => {

    const [orderStatus, setOrderStatus] = useState((props.orderStatus != null) ? props.orderStatus : "ממתין לאישור");
    const [colorforStat, setColorforStat] = useState("");

    useEffect(() => {
        setOrderStatus(props.orderStatus)
        setColorforStat(getOrdColorByStat(props.orderStatus))

    }, [props.orderStatus])

    const handleChange = (e) => {

        setOrderStatus(e.target.value)
        setColorforStat(getOrdColorByStat(e.target.value))
        props.setOrderStatus(e.target.value)

    }

    const getOrdColorByStat = (status) => {
        const statusClassMap = {
            "ממתין לאישור": "badge badge-primary",
            "מוזמן": "badge badge-finished",
            "מאושר": "badge badge-finished",
            "סגור": "badge badge-dark",
            "מושהה": "badge badge-Delayed",
            "מבוטל": "badge badge-dark",

        };

        return statusClassMap[status] || "badge badge-primary";
    }

    return (
        <>
            <span style={props.inStyle} className={`${colorforStat} 'pointing' `}>
                <select
                    className={`onLeft selectInBlock`}
                    value={orderStatus}
                    onChange={handleChange}>
                    <option value={"ממתין לאישור"}>ממתין לאישור</option>
                    <option value={"מוזמן"}>מוזמן</option>
                    <option value={"מאושר"}>מאושר</option>
                    <option value={"סגור"} >סגור</option>
                    <option value={"מושהה"} >מושהה</option>
                    <option value={"מבוטל"} >מבוטל</option>
                </select>
            </span>
        </>
    );
}

export default TblOrderStatuselect;